<template>
	<div class="toast" :class="[{'fadeIn': visiable}, {'top': fadeInTop}, theme]">
		{{message}}
	</div>
</template>
<style>
.toast {
    position: fixed;
    padding: 10px 40px;
    font-size: 13px;
    top: 0;
    left: 50%;
    z-index: 222;
    transform: translate(-50%);
    opacity: 0;
    color: white;
    transition: margin-top 0.8s ease-out, opacity 0.8s ease-out;
}
.top.toast {
    margin-top: -34px;
    z-index: 999;
}
.fadeIn {
    margin-top: 108px;
    opacity: 1;
}
.top.fadeIn {
    margin-top: 0
}
.warning {
    background-color: #ffc100;
    color: black;
}
.danger {
    background-color: #cc0000;
}
.success {
    background-color: #00982c;
}
.primary {
    background-color: #e85d0c;
}
</style>
<script>
export default {
    data() {
        return {
            message: "",
            visiable: false,
            theme: "primary",
            fadeInTop: false  
        };
    }
};
</script>


// WEBPACK FOOTER //
// src/components/toast/toast.vue